import React from 'react';
import PropTypes from 'prop-types';

const DateTime = ({ date, time }) => 
  <div className="date-time">
    <span>{date}</span>
    <span>{time}</span>
  </div>

DateTime.propTypes = {
  date: PropTypes.string.isRequired,
  time: PropTypes.string
}

export default DateTime;


// WEBPACK FOOTER //
// ./src/components/DateTime.js